import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, Field } from "formik";
import cl from "classnames";
import stage0Classes from "../../styles/initialEventDetails.module.scss";
import classes from "../../styles/styles.module.scss";
import { ConfigContext } from "../../context";
import { Flavour, venueFinderFlavours } from "../../constants";
import VenueTypeOptions from "venuescanner-js/react/components/VenueTypeOptions";
import { getStyles } from "venuescanner-js/services/tagService";

const cateringOptions = [
  { value: "venue", label: "Go with the venue’s caterer" },
  { value: "external", label: "Bring an external caterer" },
  { value: "self", label: "Bring my own food & drinks" },
  { value: "full_bar", label: "Full bar required" },
  { value: "tea_coffee", label: "Tea & coffee required" },
];

const CATERING_NAME = "catering";
const toggleCatering = (formik, value) => () => {
  window.dataLayer.push({ event: CATERING_NAME });
  formik.setFieldValue(CATERING_NAME, {
    ...formik.values[CATERING_NAME],
    [value]: !formik.values[CATERING_NAME][value],
  });
};

const CateringOption = connect(({ formik, simple }) => (
  <div className={classes.FieldWrapper}>
    <p>What are you planning for food &amp; drinks?</p>
    {simple ? (
      <div>
        <Field
          type="checkbox"
          className={cl("ux-checkbox", stage0Classes.FlexibleInput)}
          value={formik.values[CATERING_NAME].any}
          onChange={toggleCatering(formik, "any")}
          name="catering[any]"
          id="catering-any"
        />
        <label htmlFor="catering-any" className={stage0Classes.CheckboxLabel}>
          I'd like catering to be included
        </label>
      </div>
    ) : (
      cateringOptions.map(({ value, label }) => (
        <div key={value}>
          <Field
            type="checkbox"
            className={cl("ux-checkbox", stage0Classes.FlexibleInput)}
            value={formik.values[CATERING_NAME][value]}
            onChange={toggleCatering(formik, value)}
            name={value}
            id={`catering-${value}`}
          />
          <label
            htmlFor={`catering-${value}`}
            className={stage0Classes.CheckboxLabel}
          >
            {label}
          </label>
        </div>
      ))
    )}
  </div>
));

CateringOption.propTypes = {
  simple: PropTypes.bool.isRequired,
};

const StylesOptions = connect(
  ({
    formik: {
      values: { [STYLES_NAME]: value, eventType },
      setFieldValue,
    },
    styles: providedStyles = [],
    flavour,
    base,
  }) => {
    const [styles, setStyles] = useState(providedStyles);
    useEffect(() => {
      if (styles.length > 0) return;
      getStyles(base).then(setStyles);
    }, [styles, base]);

    if (!eventType) return null;
    const isCorporate = !!eventType.isCorporate;
    const shouldRedirectToSrp =
      flavour === Flavour.VENUE_SEARCH ||
      (venueFinderFlavours.includes(flavour) && !isCorporate);
    if (shouldRedirectToSrp) return null;

    return (
      <div className={classes.FormControl}>
        <div className={classes.FieldWrapper}>
          <p>What ambience are you aiming for?</p>
          <VenueTypeOptions
            blue
            options={styles}
            value={value}
            onChange={(val) => setFieldValue(STYLES_NAME, val)}
          />
        </div>
      </div>
    );
  }
);

const STYLES_NAME = "styles";
const StylesAndCateringStage = ({ styles }) => {
  const { flavour, base } = useContext(ConfigContext);
  const simpleCatering = flavour === Flavour.VENUE_SEARCH;

  return (
    <div className={classes.Form}>
      <div className={classes.StageWrapper}>
        <StylesOptions flavour={flavour} styles={styles} base={base} />
        <div className={classes.FormControl}>
          <CateringOption simple={simpleCatering} />
        </div>
      </div>
    </div>
  );
};

StylesAndCateringStage.propTypes = {
  styles: PropTypes.arrayOf(PropTypes.string),
};

export default StylesAndCateringStage;
